import { render, staticRenderFns } from "./ComprehensiveInsurance.vue?vue&type=template&id=7601d415&"
import script from "./ComprehensiveInsurance.vue?vue&type=script&lang=js&"
export * from "./ComprehensiveInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports